<script>
    import { params } from "@roxi/routify";
    import { ServiceConsts } from "../../../services/ServiceConsts";
    import { LocalStorage } from "../../../services/LocalStorage";

    if ($params.redirectUrl) {
        LocalStorage.set("IN_APP_REDIRECT", $params.redirectUrl);
    }
    window.location.replace(
        ServiceConsts.LOGIN_URL +
            "?redirectUrl=" +
            window.location.origin +
            "/auth/extension/",
    );
</script>

Redirecting to auth server...
